import CodeTab from '@/components/TabSpr.vue'
import CostTab from '@/components/TabSpr.vue'
import http from '@/http-common'

export default {
    name: "AnalyticCodePage",
    components: {CodeTab, CostTab},
    data() {
        return{
            captionTable:'КОСГУ(Статьи)',
            columns: [
                {key: 'code', label: 'Код', tdClass: 'nameClass1'},
                {key: 'statiya', label: 'Статья', tdClass: 'nameClass2'},
                {key: 'edit_field', label: ''}
            ],
            columnsCost: [
                {key: 'nameCost', label: 'Наименование'},
                {key: 'fullName', label: 'Полное наименование'},
                {key: 'stateCost', label: 'На печать', tdClass: 'nameClass1'},
                {key: 'usePercent', label: '', tdClass: 'nameClass1'},
                {key: 'show_childs', label: '', tdClass: 'nameClass1'},
                {key: 'edit_field', label: '', tdClass: 'nameClass1'},
            ],
            columnsChild: [
                {key: 'nameCost', label: 'Наименование'},
                {key: 'fullName', label: 'Полное наименование'},
                {key: 'edit_field', label: '', tdClass: 'nameClass1'},
            ],
            items: [],
            selectedItem: {
                code: '',
                statiya: ''
            },
            costs: [],
            selectedCost: {
                nameCost: '',
                fullName: ''
            },
            caption: {
                name: 'Коды аналит/учета',
                nameR: 'код аналит/учета'
            },
            captionCost: {
                name: 'Расход',
                nameR: 'расход'
            },
            urls: {
                save: '/cost/analytic',
                delete: '/cost/analytic',
            },
            urlsCost: {
                save: '/cost',
                delete: '/cost',
            },
            modalEditOpened: false,
            validValue: {
                code: true,
                statiya: true,
                form: true
            },
            percent: ''
        }
    },
    created() {
        this.getPercent();
        this.loadItems();
    },
    methods: {
        checkForm() {
            for (var key in this.validValue) {
                this.validValue[key] = true;
            }
            if (!this.selectedItem.code || this.selectedItem.code === '') {
                this.validValue.code = false;
                this.validValue.form = false;
            }
            if (!this.selectedItem.statiya || this.selectedItem.statiya === '') {
                this.validValue.statiya = false;
                this.validValue.form = false;
            }
        },
        loadItems() {
            var vm = this;
            http.get('/cost/analytic/list')
                .then((response) => {
                    vm.items = response.data;
                })
                .catch((error) => console.log(error.response.data));
        },
        loadCosts() {
            var vm = this;
            http.get('/cost/listByCode/'+this.selectedItem.id)
                .then((response) => {
                    vm.costs = response.data;
                })
                .catch((error) => console.log(error.response.data));
        },
        showEditDialog() {
            if (this.selectedItem.id == null)
                this.costs = [];
            else
                this.loadCosts();
            this.modalEditOpened = !this.modalEditOpened;
        },
        showEditDialogCost() {
            this.modalEditOpenedCost = !this.modalEditOpenedCost;
        },
        saveAnalytic() {
            this.checkForm();
            if (this.validValue.form) {
                this.selectedItem.costs = this.costs;
                this.$refs.CodeTab.save(this.selectedItem);
                this.modalEditOpened = false;
            }
        },
        addCostRow() {
            var row = {
                id: 0,
                name: '',
                fullname: ''
            };
            this.costs.push(row);
        },
        addChildRow(row) {
            var child = {
                id: 0,
                name: '',
                fullname: ''
            };
            this.costs[row.index].childs.push(child);
        },
        deleteCost(index) {
            this.costs.splice(index,1)
        },
        deleteChild(row, index) {
            this.costs[row.index].childs.splice(index,1)
        },
        iconVal(row) {
            if (row.detailsShowing)
                return 'chevron-up';
            else
                return 'chevron-down';
        },
        titleVal(row) {
            if (row.detailsShowing)
                return 'Скрыть подразделы';
            else
                return 'Показать подразделы';
        },
        getPercent() {
            var sett;
            http.get('/setting/smeta')
                .then((response) => {
                    if (response.data != null && response.data !== "")
                        sett = response.data;
                    if (sett && sett.percent && sett.percent>0) {
                        this.percent = '* - процент начисления по ГПХ = '+sett.percent+'%';
                    } else
                        this.percent = ''
                })
                .catch((error) => console.log(error.response.data));
        }
    },
    computed: {

    }
}
